// // import React, { useState } from 'react';
// // import { useHistory } from 'react-router-dom';
// import { signupOwner } from '../../services/authService';

// import React, { useState } from 'react';
// // import { ownerSignup } from '../services/authService';
// // import { useHistory } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';

// // import Toast from '../components/common/Toast';

// import { toast } from 'react-toastify';

// function OwnerSignup() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [name, setName] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [loading, setLoading] = useState(false);

//   //   const history = useHistory();
//   const navigate = useNavigate();

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     if (password !== confirmPassword) {
//       toast('Passwords do not match', 'error');
//       return;
//     }
//     try {
//       setLoading(true);

//       const response = await signupOwner(name, email, password);
//       if (response.token) {
//         localStorage.setItem('ownerToken', response.token);
//         // const response = await axios.post('/api/auth/owner-signup', {
//         //   name,
//         //   email,
//         //   password,
//         // });
//         setSuccess('Account created successfully!');
//         setName('');
//         setEmail('');
//         setPassword('');
//         // history.push('/owner-dashboard');
//         navigate('/owner/dashboard');
//       } else {
//         setError('Signup failed. Please try again.');

//         toast.error('Signup failed.');
//       }
//     } catch (error) {
//       // setError('Signup failed. Please try again.');

//       // toast.error('Error during signup.');
//       if (error.response?.status === 409) {
//         toast.error('Email already exists');
//       } else if (error.response?.status === 422) {
//         toast.error(error.response.data.message);
//       } else {
//         setError('Signup failed. Please try again.');

//         toast.error('Failed to create account');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
//       <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
//         <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
//           Owner Signup
//         </h2>
//         {error && <p className='text-red-500 mb-4'>{error}</p>}
//         {success && <p className='text-green-500 mb-4'>{success}</p>}

//         <input
//           type='text'
//           className='w-full p-3 mb-4 border rounded-lg'
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder='Enter your name'
//         />
//         <input
//           type='text'
//           className='w-full p-3 mb-4 border rounded-lg'
//           placeholder='Enter your email'
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           type='password'
//           className='w-full p-3 mb-4 border rounded-lg'
//           placeholder='Enter your password'
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />

//         <input
//           type='password'
//           value={confirmPassword}
//           placeholder='Confirm password'
//           className='w-full p-3 mb-4 border rounded-lg'
//           onChange={(e) => setConfirmPassword(e.target.value)}
//           required
//         />

//         <button
//           className='bg-blue-500 text-white py-2 px-4 rounded-lg'
//           onClick={handleSignup}
//           disabled={loading}
//         >
//           {loading ? 'Signing up...' : 'Signup'}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default OwnerSignup;

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { signupOwner, loginOwner } from '../../services/authService';
import { toast } from 'react-toastify';
import { useAuth } from './context/AuthContext';

// Password validation helper
const validatePassword = (password) => {
  const validations = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const allValid = Object.values(validations).every(Boolean);

  return {
    isValid: allValid,
    validations,
  };
};

function OwnerSignup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    validations: {
      length: false,
      uppercase: false,
      lowercase: false,
      number: false,
      special: false,
    },
  });

  const navigate = useNavigate();
  const location = useLocation();

  const { ownerLogin, isOwnerAuthenticated } = useAuth();

  useEffect(() => {
    if (isOwnerAuthenticated) {
      const { from } = location.state || { from: '/owner/dashboard' };
      navigate(from, { replace: true });
    }
  }, [isOwnerAuthenticated, navigate, location]);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordValidation(validatePassword(newPassword));
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');

    // Validate required fields
    if (!name || !email || !password || !confirmPassword) {
      toast.error('All fields are required');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    // Validate password
    if (!passwordValidation.isValid) {
      toast.error('Please ensure password meets all requirements');
      return;
    }

    // Check password match
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setLoading(true);
      const response = await signupOwner(name, email, password);

      if (response.token) {
        localStorage.setItem('ownerToken', response.token);
        setSuccess('Account created successfully!');
        toast.success('Account created successfully!');
        // navigate('/owner/dashboard');
        ownerLogin(response.token);
        // toast.success('Login successful');
        const { from } = location.state || { from: '/owner/dashboard' };
        navigate(from, { replace: true });
      }
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error('Email already exists');
      } else if (error.response?.status === 422) {
        toast.error(error.response.data.message);
      } else {
        setError('Signup failed. Please try again.');
        toast.error('Failed to create account');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900 py-8'>
      <div className='bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md'>
        <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
          Owner Signup
        </h2>

        {error && <p className='text-red-500 mb-4'>{error}</p>}
        {success && <p className='text-green-500 mb-4'>{success}</p>}

        <form onSubmit={handleSignup} className='space-y-4'>
          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
              Name
            </label>
            <input
              type='text'
              className='w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500'
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='Enter your name'
              required
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
              Email
            </label>
            <input
              type='email'
              className='w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500'
              placeholder='Enter your email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
              Password
            </label>
            <input
              type='password'
              className='w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500'
              placeholder='Enter your password'
              value={password}
              onChange={handlePasswordChange}
              required
            />

            {/* Password requirements checklist */}
            <div className='mt-2 text-sm space-y-1'>
              <p
                className={
                  passwordValidation.validations.length
                    ? 'text-green-500'
                    : 'text-gray-500'
                }
              >
                ✓ At least 8 characters
              </p>
              <p
                className={
                  passwordValidation.validations.uppercase
                    ? 'text-green-500'
                    : 'text-gray-500'
                }
              >
                ✓ Contains uppercase letter
              </p>
              <p
                className={
                  passwordValidation.validations.lowercase
                    ? 'text-green-500'
                    : 'text-gray-500'
                }
              >
                ✓ Contains lowercase letter
              </p>
              <p
                className={
                  passwordValidation.validations.number
                    ? 'text-green-500'
                    : 'text-gray-500'
                }
              >
                ✓ Contains number
              </p>
              <p
                className={
                  passwordValidation.validations.special
                    ? 'text-green-500'
                    : 'text-gray-500'
                }
              >
                ✓ Contains special character
              </p>
            </div>
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
              Confirm Password
            </label>
            <input
              type='password'
              value={confirmPassword}
              placeholder='Confirm password'
              className='w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500'
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type='submit'
            className='w-full bg-blue-500 text-white py-3 px-4 rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
            disabled={loading || !passwordValidation.isValid}
          >
            {loading ? (
              <span className='flex items-center justify-center'>
                <svg
                  className='animate-spin -ml-1 mr-3 h-5 w-5 text-white'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                >
                  <circle
                    className='opacity-25'
                    cx='12'
                    cy='12'
                    r='10'
                    stroke='currentColor'
                    strokeWidth='4'
                  ></circle>
                  <path
                    className='opacity-75'
                    fill='currentColor'
                    d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                  ></path>
                </svg>
                Signing up...
              </span>
            ) : (
              'Sign Up'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default OwnerSignup;

// const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await ownerSignup({ email, password });
//       localStorage.setItem('ownerToken', response.token);
//       Toast.success('Signup successful');
//       navigate('/owner-dashboard');
//     } catch (error) {
//       Toast.error('Signup failed. Please try again.');
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto mt-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">Owner Signup</h1>
//       <form onSubmit={handleSubmit}>
//         <div className="mb-4">
//           <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//           <input
//             type="email"
//             id="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <div className="mb-4">
//           <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
//           <input
//             type="password"
//             id="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <button
//           type="submit"
//           className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
//         >
//           Signup
//         </button>
//       </form>
//     </div>
//   );

// return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
//       <h2 className="text-2xl font-bold mb-4">Owner Signup</h2>
//       <input
//         type="email"
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <input
//         type="password"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <button
//         onClick={handleSignup}
//         className="bg-green-500 text-white px-4 py-2 rounded"
//       >
//         Sign Up
//       </button>
//     </div>
//   );
